import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';

import { IconLink, theme } from '@sg/garnish';

import { type HeaderLeftProps } from '../../Header.props';

export const HeaderLeft = (props: HeaderLeftProps) => {
  const { testID, items = [], tintColor } = props;

  const shouldRenderHeader = items.length > 0;

  if (!shouldRenderHeader) return null;

  return (
    <View testID={testID} style={styles.headerLeft}>
      {items.map(({ key, ref, icon, ...rest }) => (
        <IconLink
          key={key}
          ref={ref}
          name={icon}
          style={styles.headerLeftItem}
          color={tintColor}
          {...rest}
        />
      ))}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const headerSidePadding = Platform.OS === 'web' ? theme.spacing['4'] : 0;

const styles = StyleSheet.create({
  headerLeft: {
    flexDirection: 'row',
    paddingLeft: headerSidePadding,
  },
  headerLeftItem: {
    marginRight: theme.spacing['6'],
    marginLeft: Platform.select({
      ios: -theme.spacing['1'],
      default: 0,
    }),
  },
});
